import { render, staticRenderFns } from "./HomeNew.vue?vue&type=template&id=487995ac&scoped=true&"
import script from "./HomeNew.vue?vue&type=script&lang=js&"
export * from "./HomeNew.vue?vue&type=script&lang=js&"
import style0 from "./HomeNew.vue?vue&type=style&index=0&id=487995ac&prod&lang=scss&scoped=true&"
import style1 from "./HomeNew.vue?vue&type=style&index=1&id=487995ac&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "487995ac",
  null
  
)

export default component.exports